import { http } from "../../../services/apiSecurity/Http.interceptor";
import { ResponsePagination } from "../../../core/interfaces/ResponsePagination";
import Component from './interfaces/Component';
import { Pagination } from "../../../component/table/interfaces/Pagination";

const URL: string = '/componentes';

export const getComponent = (params?: Pagination) => {
    return http.get<ResponsePagination>(URL, { params: params })
}

export const getByComponent = (id: number) => {
    return http.get<Component>(`${URL}/${id}`)
}

export const postComponent = (component: Component) => {
    return http.post<Component>(URL, component)
}

export const deleteComponent = (id: number) => {
    return http.delete<string>(`${URL}/${id}`)
}

export const putComponent = (component: Component) => {
    return http.put<Component>(`${URL}/${component.id}`, component)
}